import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustedBy from "./components/TrustedBy";
import Services from "./components/Services";
import SmartQuote from "./components/aimflex/SmartQuote";
import Portfolio from "./components/Portfolio";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { ThemeProvider } from "./components/theme-provider";
import { useRevealOnScroll } from "./hooks/useRevealOnScroll";

const Home = () => {
  useRevealOnScroll();

  return (
    <div className="site-shell min-h-screen bg-background text-foreground selection:bg-[#FF2A00] selection:text-white">
      <Header />
      <Hero />
      <TrustedBy />
      <Services />
      <SmartQuote />
      <Portfolio />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
